import React from 'react';

const Skeleton = ({
  variant = 'text',
  width,
  height,
  className = '',
  circle = false,
}) => {
  const variants = {
    text: 'h-4',
    title: 'h-6',
    subtitle: 'h-5',
    avatar: 'h-12 w-12',
    thumbnail: 'h-20 w-20',
    image: 'h-40',
    card: 'h-64',
    button: 'h-12',
  };

  const baseClasses = `
    skeleton
    bg-[#EFEDEA]
    ${circle ? 'rounded-full' : 'rounded-lg'}
    ${variants[variant]}
    ${className}
  `;

  const style = {
    width: width,
    height: height,
  };

  return (
    <div 
      className={baseClasses}
      style={style}
      aria-hidden="true"
    />
  );
};

// Skeleton para tarjetas de producto
export const ProductCardSkeleton = () => (
  <div className="bg-white rounded-2xl p-4 shadow-md">
    <Skeleton variant="image" className="w-full rounded-xl mb-4" />
    <Skeleton variant="title" width="80%" className="mb-2" />
    <Skeleton variant="text" width="60%" className="mb-4" />
    <div className="flex justify-between items-center">
      <Skeleton variant="text" width="40%" />
      <Skeleton variant="button" width="80px" className="rounded-xl" />
    </div>
  </div>
);

// Skeleton para lista
export const ListSkeleton = ({ count = 3 }) => (
  <div className="space-y-4">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="flex gap-4 bg-white p-4 rounded-2xl shadow-md">
        <Skeleton variant="thumbnail" circle />
        <div className="flex-1 space-y-2">
          <Skeleton variant="title" width="70%" />
          <Skeleton variant="text" width="50%" />
          <Skeleton variant="text" width="30%" />
        </div>
      </div>
    ))}
  </div>
);

// Grid de skeletons
export const ProductGridSkeleton = ({ count = 6 }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
    {Array.from({ length: count }).map((_, i) => (
      <ProductCardSkeleton key={i} />
    ))}
  </div>
);

export default Skeleton;
